import React from 'react'
import gql from 'graphql-tag'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'

const SlidesProduct = ({product}) => {
  if (product.state === 'delivered') {
    return (
      <DeliveredUrl product={product} />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

SlidesProduct.fragment = gql`
  fragment SlidesProduct on Product {
    ...on SlidesProduct {
      assets {
        edges {
          node {
            id
            state
            ...on UrlAsset {
              url
            }
          }
        }
      }
    }
  }
`

export default SlidesProduct
